import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { track } from "@/lib/analytics";

const WA_NUMBER = "918800288994"; // +91 88002 88994
const WA_TEXT = encodeURIComponent(
  "Hi KIKI Centre for Technology, I'm interested in the Session 2026 programme. Please share admission details."
);

export function WhatsAppFAB() {
  const [show, setShow] = useState(false);
  const [tip, setTip] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1400);
    const tp = setTimeout(() => setTip(true), 3200);
    const tp2 = setTimeout(() => setTip(false), 9000);
    return () => { clearTimeout(t); clearTimeout(tp); clearTimeout(tp2); };
  }, []);

  const open = () => {
    track("whatsapp_fab_click");
    window.open(`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`, "_blank", "noopener");
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-5 left-5 z-40 flex items-center gap-3"
        >
          <button
            onClick={open}
            data-testid="whatsapp-fab"
            aria-label="Chat on WhatsApp"
            className="relative w-14 h-14 rounded-full grid place-items-center bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform"
          >
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
            <MessageCircle className="w-6 h-6 relative" strokeWidth={2} fill="currentColor" />
          </button>
          <AnimatePresence>
            {tip && (
              <motion.div
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -10 }}
                className="hidden sm:flex items-center gap-2 bg-card border border-border rounded-full pl-4 pr-2 py-2 shadow-lg"
              >
                <span className="text-sm font-medium">Chat with admissions on WhatsApp</span>
                <button onClick={() => setTip(false)} className="w-6 h-6 grid place-items-center rounded-full hover:bg-muted" aria-label="Dismiss">
                  <X className="w-3.5 h-3.5" strokeWidth={1.8} />
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
